import { render, staticRenderFns } from "./DashboardUserMessages.vue?vue&type=template&id=2e9a79ac&scoped=true"
import script from "./DashboardUserMessages.vue?vue&type=script&lang=ts"
export * from "./DashboardUserMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a79ac",
  null
  
)

export default component.exports